// viewport.wgsl — maps a pixel coordinate to the complex-plane point it
// represents. Concatenated ahead of every formula shader alongside
// complex.wgsl (see src/util/pipeline.mjs).

// `scale` is complex-plane units per pixel; `center_im` grows upward so the
// canvas reads like a normal math plot rather than screen coordinates.
fn pixelToComplex(
  px: u32, py: u32,
  width: u32, height: u32,
  center_re: f32, center_im: f32,
  scale: f32,
) -> Complex {
  let half_w = f32(width) * 0.5;
  let half_h = f32(height) * 0.5;
  return Complex(
    center_re + (f32(px) - half_w) * scale,
    center_im - (f32(py) - half_h) * scale,
  );
}
